import { CosmosSigner } from '@polaris/core/cosmos'
import type { DerivationPaths } from '@polaris/core/services/server'
import { Hotkey, type RestoredHotkey } from '@polaris/core/signing'
import { atom } from 'jotai'

/** Used for deriving addresses for specific cosmos chains in keyrings. */
export const cosmosDerivationPathsAtom = atom<DerivationPaths>({
  'cosmoshub-1': CosmosSigner.DEFAULT_COSMOS_CHAIN_METADATA,
})

/**
 * This atom is used to trigger updates when hotkeys are generated outside of React
 * This is needed to ensure that the hotkey is updated in the UI when it is generated
 * outside of React.
 */
export const hotkeyUpdateTriggerAtom = atom(0)

export const singletonHotkeyAtom = atom<RestoredHotkey | undefined>((get) => {
  // Get the trigger value to force updates when needed
  get(hotkeyUpdateTriggerAtom)

  return Hotkey.restoreSingleton(get(cosmosDerivationPathsAtom))
})
